module.exports = __webpack_public_path__ + "img/Slice9.6bee5e53.png";